import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { TrendingUp } from "lucide-react";
import { resolveAssetUrl } from "@/lib/assetUrl";

/**
 * Right-hand "Trending Boards" widget for the Blinterest home.
 * Desktop only (hidden on mobile via lg: breakpoint from the parent grid).
 * Shows top public boards ordered by pin_count, with cover thumbnail + count.
 */
export default function TrendingBoardsRail() {
  const [boards, setBoards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/blinterest/boards/trending?limit=6`)
      .then((r) => setBoards(r.data.boards || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <aside className="space-y-4" data-testid="trending-boards-rail">
      <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
        <div className="flex items-center gap-2 mb-3">
          <TrendingUp className="w-4 h-4 text-tbc-gold" />
          <h3 className="font-heading text-white text-base">Trending Collections</h3>
        </div>
        {loading ? (
          <div className="space-y-3">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="h-12 bg-white/10 rounded-lg animate-pulse" />
            ))}
          </div>
        ) : boards.length === 0 ? (
          <p className="text-white/50 text-xs font-body">
            No trending Collections yet — start one to be the first.
          </p>
        ) : (
          <ul className="space-y-2">
            {boards.map((b) => (
              <li key={b.board_id}>
                <Link
                  to={`/blinterest/board/${b.board_id}`}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-white/5 transition-colors group"
                  data-testid={`trending-board-${b.board_id}`}
                >
                  <div className="w-10 h-10 rounded-lg overflow-hidden bg-white/10 flex-none">
                    {b.cover_image ? (
                      <img
                        src={resolveAssetUrl(b.cover_image)}
                        alt=""
                        className="w-full h-full object-cover"
                      />
                    ) : null}
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-white text-sm font-body truncate group-hover:text-tbc-gold transition-colors">
                      {b.name}
                    </p>
                    <p className="text-[10px] text-white/50">
                      {b.pin_count} Find{b.pin_count === 1 ? "" : "s"}
                    </p>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Business acquisition card */}
      <div className="rounded-2xl border border-tbc-gold/40 bg-white/5 p-4">
        <p className="text-tbc-gold text-[10px] uppercase tracking-widest font-semibold mb-2">
          Are you a Black-owned business?
        </p>
        <p className="text-white/80 font-body text-sm mb-3 leading-relaxed">
          Share your Drops, connect with the community, and get discovered on Blinterest.
        </p>
        <Link
          to="/join?intent=business"
          className="inline-block bg-tbc-gold hover:bg-tbc-gold/90 text-tbc-navy font-heading text-sm px-4 py-2 rounded-full transition-colors"
          data-testid="rail-add-business-btn"
        >
          Add Your Business
        </Link>
      </div>
    </aside>
  );
}
